exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-list {\n  border-right: 1px solid #ccc;\n  max-height: 60vh;\n  overflow: auto;\n}\n#hidden {\n  display: none;\n}\ninput[type=\"file\"] {\n  display: none;\n}\n.progress {\n  display: none;\n}\n.custom-file-upload {\n  border: 1px solid #ccc;\n  display: inline-block;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n.custom-file-upload:hover {\n  background-color: #d2d6de;\n  color: #fff;\n}\n#hidden {\n  display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/media-selector/media-selector.component.less
// module id = ../../../../../src/app/components/media-selector/media-selector.component.less
// module chunks = 0